<template>
    <div class="module-form">
      <!-- <div class="module-header">
        <a-icon type="arrow-left" class="module-back"  @click="back()"/>
        {{ currentModule.name }}
      </div> -->
      <div class="title-panel">
        <div class="module-card" :class="currentModule.code==item.code?'module-card-selected':''" v-for="(item,index) in data" :key="item.code" @click="selectModule(index)">
          <div class="one-row module-name" >
            <label>
              {{item.name}}
            </label>

          </div>
          <div class="module-form-num">
              <label v-if="item.checkedFormList && item.checkedFormList.length>0">
                {{item.checkedFormList.length}}/{{item.formList.length}}
              </label>
            <label v-else>
              待配置
            </label>
          </div>
        </div>
      </div>
      <a-checkbox-group v-model="selectFormCodeList" style="width: 100%" v-if="!updateLoading">
        <div class="module-form-panel">
          <div class="score-form-panel">
            <div class="form-panel-title">
              <span class="title">
                推荐量表
              </span>
              <span style="color: white;">
                已选{{selectMaxFormCodeList.length}}个
              </span>
              <a-checkbox class="checkbox-all" :value="max.value" :indeterminate="max.indeterminate" @change="onMaxCheckAllChange">
                全选
              </a-checkbox>
            </div>
            <a-row :gutter="[10,10]" class="form-panel-items">
              <a-col :span="12"  v-for="(item,index) in maxFormList" :key="index">
                <form-card :form-info="item" @change="onMaxCheckChange"></form-card>
              </a-col>
            </a-row>
          </div>
          <div class="score-form-panel" style="margin-bottom: 52px">
            <div class="form-panel-title">
              <span class="title">
                其他量表
              </span>
              <span style="color: white;">
                已选{{selectOtherFormCodeList.length}}个
              </span>
              <a-checkbox class="checkbox-all" :value="other.value" :indeterminate="other.indeterminate" @change="onOtherCheckAllChange">
                全选
              </a-checkbox>
            </div>
            <a-row  class="form-panel-items">
              <a-col :span="12"  v-for="(item,index) in otherFormList" :key="index">
                <form-card :form-info="item" @change="onOtherCheckChange"></form-card>
              </a-col>
            </a-row>
          </div>
        </div>
      </a-checkbox-group>
      <div class="custom">
        <a-dropdown :trigger="['click']" class="footer-btn-link">
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            自定义量表<a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a-button type="link" @click="formDiyClick">上传量表</a-button>
            </a-menu-item>
            <a-menu-item>
              <a-button type="link" @click="formDiyListClick">历史上传</a-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <div class="footer" >
          <template v-if="currentModuleIndex>0">
            <a-button type="link" class="footer-btn-lase"  @click="laseForm">上一项</a-button>
            <a-button type="primary" class="footer-btn2" @click="nextForm">{{ currentModuleIndex== data.length-1 ? '保存': '下一项'}}</a-button>
          </template>
          <template v-else>
            <a-button type="primary" class="footer-btn1" @click="nextForm">{{ currentModuleIndex== data.length-1 ? '保存': '下一项'}}</a-button>
          </template>
      </div>
      <module-form-diy ref="module-form-diy" :moduleList="data" :project="project" :diseaseCode="diseaseCode"></module-form-diy>
      <module-form-diy-list ref="module-form-diy-list" :project="project" :diseaseCode="diseaseCode"></module-form-diy-list>
    </div>
</template>

<script>
  import { getAction } from '@api/manage'
  import ModuleFormDiy from '@views/apppad/projectTemplate/projectTemplate2/ModuleFormDiy.vue'
  import ModuleFormDiyList from '@views/apppad/projectTemplate/projectTemplate2/ModuleFormDiyList.vue'
  import FormCard from '@views/apppad/projectTemplate/comp/FormCard.vue'

  export default {
    name: 'ModuleForm',
    components: { FormCard, ModuleFormDiyList, ModuleFormDiy },
    props:{
      data:{
        type:Array,
        default:()=>{
          return []
        }
      },
      project:{
        type:Object,
        default:()=>{
          return { }
        }
      },
      diseaseCode:{
        type:String,
        default:''
      }
    },
    data(){
      return {
        currentModule: { },
        currentModuleIndex:0,
        selectFormCodeList:[],
        max:{
          indeterminate:false,
          value:'@-max-@',
        },
        other:{
          indeterminate:false,
          value:'@-other-@',
        },
        updateLoading:false,
      }
    },
    computed:{
      maxFormList(){
        const result = []
        if(this.currentModule && this.currentModule.formList){
          this.currentModule.formList.forEach(item=>{
            if(item.score>=4.5){
              result.push(item)
            }
          })
        }
        return result
      },
      selectMaxFormCodeList(){
        const result = []
        this.maxFormList.forEach(item=>{
          if(this.selectFormCodeList.indexOf(item.code)>=0){
            result.push(item.code)
          }
        })
        return result
      },
      otherFormList(){
        const result = []
        if(this.currentModule && this.currentModule.formList){
          this.currentModule.formList.forEach(item=>{
            if(item.score<4.5){
              result.push(item)
            }
          })
        }
        return result
      },
      selectOtherFormCodeList(){
        const result = []
        this.otherFormList.forEach(item=>{
          if(this.selectFormCodeList.indexOf(item.code)>=0){
            result.push(item.code)
          }
        })
        return result
      }
    },
    mounted(){
      this.loadData()
      this.selectModule(0)
    },
    methods:{
      laseForm(){
        const index = this.currentModuleIndex - 1
        this.selectModule(index)
      },
      nextForm(){
        if(this.currentModuleIndex < this.data.length-1){
          const index = this.currentModuleIndex + 1
          this.selectModule(index)
        }
        else{
          this.save()

        }
      },
      formDiyClick(){
        this.$refs['module-form-diy'].open()
      },
      formDiyListClick(){
        this.$refs['module-form-diy-list'].open()
      },
      save(){
        const saveData = []
        this.data.forEach(item=>{
          saveData.push({
            checkedFormList:item.checkedFormList,
            code:item.code,
            icon:item.icon,
            name:item.name,
          })
        })
        this.$emit("save",saveData)
      },
      onMaxCheckChange(e){
        this.$nextTick(()=>{
          this.onCheckChange('max',this.selectMaxFormCodeList,this.maxFormList)
        })

      },
      onOtherCheckChange(e){
        this.$nextTick(()=>{
          this.onCheckChange('other',this.selectOtherFormCodeList,this.otherFormList)
        })
      },
      onCheckChange(checkedObjKey,selectFormCodeList,formList){
        const checkedObj = JSON.parse(JSON.stringify(this[checkedObjKey]))
        checkedObj.indeterminate = !!selectFormCodeList.length && selectFormCodeList.length < formList.length;
        const checkAll = selectFormCodeList.length === formList.length;
        const maxIndex = this.selectFormCodeList.indexOf(checkedObj.value)
        const newSelectFormCodeList = JSON.parse(JSON.stringify(this.selectFormCodeList))
        if(checkAll){
          if(maxIndex<0){
            newSelectFormCodeList.push(checkedObj.value)
          }
        }else{
          if(maxIndex>=0){
            newSelectFormCodeList.splice(maxIndex,1)
          }
        }
        this[checkedObjKey] = checkedObj
        this.selectFormCodeList = newSelectFormCodeList
        this.handleCheckedFormList()
      },
      onMaxCheckAllChange(e){
        this.onCheckAllChange(e,this.max,this.maxFormList)

      },
      onOtherCheckAllChange(e){
        this.onCheckAllChange(e,this.other,this.otherFormList)
      },
      onCheckAllChange(e,checkedObj,formList){
        checkedObj.indeterminate = false
        checkedObj.checkAll = e.target.checked
        this.$nextTick(()=>{
          const selectFormCodeList = JSON.parse(JSON.stringify(this.selectFormCodeList))
          formList.forEach(item=>{
            const hasIndex = selectFormCodeList.indexOf(item.code)
            if(e.target.checked){
              if(hasIndex <0){
                selectFormCodeList.push(item.code)
              }
            }else{
              if(hasIndex >=0){
                selectFormCodeList.splice(hasIndex,1)
              }
            }
          })
          this.selectFormCodeList = selectFormCodeList;
          this.handleCheckedFormList()
        })
      },
      handleCheckedFormList(){
        const checkedFormList = []
        this.currentModule.formList.forEach(item=>{
          if(this.selectFormCodeList.indexOf(item.code)>=0){
            checkedFormList.push(item)
          }
        })
        this.$set(this.currentModule,'checkedFormList',checkedFormList)
      },
      loadData(){
        const moduleCodes  = []
        this.data.forEach(item=>{
          moduleCodes.push(item.code)
        })
        getAction('/projectconfigview/configForm/list',{moduleCodes:moduleCodes.join(',')}).then(res=>{
          if(res.success){

            const moduleForm = {};
            (res.result|| []).forEach(item=>{
              moduleForm[item.moduleCode] = moduleForm[item.moduleCode] || []
              moduleForm[item.moduleCode].push(item)
            })
            this.data.forEach(module=>{
              this.$set(module,'formList',moduleForm[module.code] || [])
            })
          }
        })
      },
      selectModule(index){
        this.updateLoading = true
        this.selectFormCodeList=[]
          this.max={
          indeterminate:false,
            value:'@-max-@',
        }
        this.other={
          indeterminate:false,
            value:'@-other-@',
        }
        this.currentModule = this.data[index]
        this.$set(this.currentModule,'checkedFormList',this.currentModule.checkedFormList || [])
        this.currentModuleIndex = index
        this.currentModule.checkedFormList.forEach(item=>{
          this.selectFormCodeList.push(item.code)
        })

        this.$nextTick(()=>{
          this.updateLoading = false
        })

      },
      back(){
        this.$emit('backHandle')
      },
    }
  }
</script>

<style scoped lang="less">
  .module-form{
    overflow-y: auto;
    .custom{
      .footer-btn-link{
        width: 100px;
        color: white;
      }
    }
    .footer{
      width: 96%;
      position: absolute;
      bottom: 20px;

      .footer-btn1{
        width: 100%;
        border: none;
        border-radius: 20px;
        background: linear-gradient( 90deg, #376EFF 0%, #DE5DFE 100%);
      }
      
      .footer-btn-lase{
        width: 50%;
        color: white;
        background: rgba(255, 255, 255, 0.15);
        border: none;
        border-radius: 21px 0 0 21px !important;
      }
      .footer-btn2{
        width: 50%;
        color: white;
        background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
        border: none;
        border-radius: 0 21px 21px 0 !important;
      }
    }
    .module-header{
      font-size: 24px;
      color: white;
      font-weight: bold;
      text-align: center;
      position: relative;
    }
    .title-panel{
      overflow-x: auto;
      white-space: nowrap;
      width: 100%;

      .module-card{
        display: inline-table;
        width: 120px;
        text-align: center;
        border: 1px solid rgba(0,0,0,0.2);
        border-radius: 5px;
        padding: 5px;
        margin: 5px;
        font-size: 12px;
        background-color: #2f3b52;
        .one-row{
        }
        .module-name{
          width: 110px;
          font-size: 18px;
          color: white;
          text-align: center;
        }
        .module-form-num{
          font-size: 12px;
          color: white;
        }
      }
      .module-card-selected{
        background-color: @primary-color;
        color: white;
      }
    }

    .score-form-panel{
      border-radius: 10px;
      border: 1px solid rgba(0,0,0,0.1);
      padding-left: 10px;
      margin-bottom: 20px;
      .form-panel-title{
        .title{
          font-size: 20px;
          color: white;
        }
        border-bottom: 1px dashed  rgba(0,0,0,0.1);
        padding-top: 10px;
        padding-bottom: 10px;
        .checkbox-all{
          color: white;
          float: right;
          margin-top: 10px;
          margin-right: 20px;
        }
      }
    }

 
  }
</style>